import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import * as React from 'react'

const LightningIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M13 2
           L5 13
           H11
           L9 22
           L19 9
           H13
           Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </SvgIcon>
  )
}

export default LightningIcon